import {
  DATA_CONNECTOR_GET_XANO_INSTANCE_BEGIN,
  DATA_CONNECTOR_GET_XANO_INSTANCE_SUCCESS,
  DATA_CONNECTOR_GET_XANO_INSTANCE_FAILURE,
  DATA_CONNECTOR_GET_XANO_INSTANCE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
export function getXanoInstance(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_GET_XANO_INSTANCE_BEGIN,
    });
    const { projectId, version } = args
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/xano/instance`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_GET_XANO_INSTANCE_SUCCESS,
            data: res.data[0],
          });
          resolve(res);

        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_GET_XANO_INSTANCE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetXanoInstanceError() {
  return {
    type: DATA_CONNECTOR_GET_XANO_INSTANCE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_GET_XANO_INSTANCE_BEGIN:
      return {
        ...state,
        getXanoInstancePending: true,
        getXanoInstanceError: null,
      };

    case DATA_CONNECTOR_GET_XANO_INSTANCE_SUCCESS:
      return {
        ...state,
        getXanoInstancePending: false,
        getXanoInstanceError: null,
        xanoInstance: action.data,
      };

    case DATA_CONNECTOR_GET_XANO_INSTANCE_FAILURE:
      return {
        ...state,
        getXanoInstancePending: false,
        getXanoInstanceError: action.data.error,
      };

    case DATA_CONNECTOR_GET_XANO_INSTANCE_DISMISS_ERROR:
      return {
        ...state,
        getXanoInstanceError: null,
      };

    default:
      return state;
  }
}
